import { Component } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-confirm-delete',
  templateUrl: './dialog-confirm-delete.component.html',
  styleUrls: ['./dialog-confirm-delete.component.scss'],
  standalone: true,
  imports: [MatDialogModule],
})
export class DialogConfirmDeleteComponent {
  constructor() {}
}
